const DEFAULT_LOCALE = "no-NO";
const SUPPORTED_LOCALES = ["en-NO", "no-NO"];
const SUPPORTED_LANGUAGES = ["en", "no"];
const SUPPORTED_COUNTRIES = ["NO"];

module.exports = {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  SUPPORTED_LANGUAGES,
  SUPPORTED_COUNTRIES,
};
